import { OFFERFIT_PIPELINE_TYPES } from "./constants";
import type { OfferfitAppGroupIdUseCasesResult, OfferfitAppGroupIdUseCasesResultItem } from "./types";

/**
 * Live agents are always shown; draft agents only when their pipeline is GO. Items
 * without a pipeline_type (legacy sync-based digest) are live-only by construction,
 * so they always pass.
 */
export const isDisplayableUseCase = (item: OfferfitAppGroupIdUseCasesResultItem): boolean =>
  item.status === "live" || item.pipeline_type === OFFERFIT_PIPELINE_TYPES.GO;

/**
 * Filters a digest result down to displayable use cases. The digest is paginated
 * (ADX-1096): `hits` is the backend's cross-page total while `results` is one page,
 * so `hits` must not be recomputed from the page length — only this page's dropped
 * rows are subtracted. The backend applies the same displayability rule, so in
 * practice nothing is dropped and `hits` passes through unchanged.
 */
export const filterDisplayableUseCases = (
  result: OfferfitAppGroupIdUseCasesResult
): OfferfitAppGroupIdUseCasesResult => {
  const results = result.results.filter(isDisplayableUseCase);
  return { ...result, hits: result.hits - (result.results.length - results.length), results };
};
